export const anRoutes = [
  {
    path: "/an",
    name: "an",
    mata: {
      KeepAlive: true
    },
    children: [
      {
        path: "ansys/navbarManagement",
        name: "ansys_navbarManagement" ,
        component: () => import('@/view/business/an/ansys/navbarManagement.vue'),
        meta: {
          KeepAlive: true,
          hasNav: true
        }
      },
      {
        path: "ansys/systemEntry",
        name: "ansys_system_entry" ,
        component: () => import('@/view/business/an/ansys/systemEntry.vue'),
        meta: {
          KeepAlive: true,
          hasNav: true
        }
      },
      
    ]
  },
  
];